import Manage from "..";
import { useEffect, useState } from "react";
import fetchDataArps from "../../../services/fetchDataArps";
import CreateWrapper from "./components/CreateWrapper";
import formatShort from "../../../utils/formatShort";
import { FiEdit } from "react-icons/fi";
import { IoCloseOutline, IoSaveOutline } from "react-icons/io5";
import postDataArps from "../../../services/postDataArps";
import formatMoney from "../../../utils/formatMoney";
import UpdateBudget from "./components/UpdateBudget";
import { message } from "antd";

export default function AllBugets() {
  const [budgets, setBudgets] = useState([]);
  const [selected, setSelected] = useState<any>(null);
  const [editable, setEditable] = useState<any>(null);
  const [updateModal, setUpdateModal] = useState<boolean>(false);

  const [opex, setOpex] = useState<number>(0);
  const [capex, setCapex] = useState<number>(0);

  const year = new Date().getFullYear();

  const handleFetchBudgets = async () => {
    const uri = `finance/budget`;
    const data = await fetchDataArps(uri);
    setBudgets(data?.payload);

    var result = data?.payload.filter((obj: any) => {
      if (!selected) {
        return obj?._id === "62a77810cc7f161f61ad1a2b";
      }

      return obj?._id === selected?._id;
    });
    setSelected(result[0]);
  };

  const handleUpdateButem = async (butem: any) => {
    const data = {
      capex_amount: Number(capex),
      opex_amount: Number(opex),
      total_amount: Number(opex) + Number(capex),
      budget: editable?.budget,
      month_code: editable?.month_code,
    };

    const uri = `finance/budget/${butem?.budget}/butem`;

    const response = await postDataArps(data, uri);
    if (response.success) {
      message.success("Updated successfully");
      setEditable(false);
      handleFetchBudgets();
    }
  };

  const getAllocatedOpex = () => {
    let total = 0;
    selected?.butems.forEach((butem: any) => {
      total = total + butem?.opex_amount;
    });

    return isNaN(total) ? 0 : total;
  };

  const getAllocatedCapex = () => {
    let total = 0;
    selected?.butems.forEach((butem: any) => {
      total = total + butem?.capex_amount;
    });
    return isNaN(total) ? 0 : total;
  };

  useEffect(() => {
    handleFetchBudgets();
  }, []);

  return (
    <Manage
      title={"Budgets"}
      subtitle={`All [ ${year} ]`}
      description={"List of department budgets"}
      actions={<CreateWrapper refetch={handleFetchBudgets} />}
    >
      <div className="grid gap-x-0 grid-cols-12">
        <div className="col-span-3 sm:col-span-3 md:col-span-3 m-4">
          <div className="grid grid-cols-12 gap-4">
            {budgets?.map((budget: any, index: number) => (
              <button
                onClick={() => setSelected(budget)}
                className={
                  selected?._id === budget?._id
                    ? `col-span-12 sm:col-span-12 md:col-span-12 mb-2 sm:mb-0 border p-4 hover:bg-gray-100 bg-gray-100 border-l-2 border-l-gray-400`
                    : "col-span-12 sm:col-span-12 md:col-span-12 mb-2 sm:mb-0 border p-4 hover:bg-gray-100"
                }
                key={index}
              >
                <div>
                  <div className="text-2xl border-b pb-4 font-bold">
                    {budget?.center?.name}
                  </div>
                  <div className="">
                    <div className="flex justify-between border-b py-2">
                      <div className="">Operational Budget</div>
                      <div className="flex justify-center items-center">
                        {formatShort(Number(budget?.opex_amount))}
                      </div>
                    </div>
                    <div className="flex justify-between">
                      <div className="">Capital Budget</div>
                      <div className="">
                        {budget?.capex_amount == 0
                          ? "-"
                          : formatShort(
                              Number(parseFloat(budget?.capex_amount))
                            )}
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
        <div className="col-span-9 sm:col-span-9 md:col-span-9 m-4">
          {selected === null ? null : (
            <div className="border p-3">
              <div className=" pb-4 flex justify-between">
                <div className="text-2xl font-bold">
                  {selected?.center?.name}
                </div>
                <div className="">
                  <button
                    onClick={() => {
                      setUpdateModal(true);
                    }}
                    className="flex justify-center items-center text-gray-700 bg-gray-200 border rounded-md p-2 hover:bg-green-200 cursor-pointer"
                  >
                    <FiEdit />
                  </button>
                  <UpdateBudget
                    isVisible={updateModal}
                    selected={selected}
                    setVisible={setUpdateModal}
                    refetch={handleFetchBudgets}
                  />
                </div>
              </div>
              <div className="border-b pb-4">
                <div className="grid grid-cols-12 gap-0">
                  <div className="col-span-3 border p-1 font-bold">
                    Budget Type
                  </div>
                  <div className="col-span-3 border p-1  font-bold">Total</div>
                  <div className="col-span-3 border p-1  font-bold">
                    Allocated
                  </div>
                  <div className="col-span-3 border p-1  font-bold">Remain</div>

                  <div className="col-span-3 border p-1 ">
                    Operational (Opex)
                  </div>
                  <div className="col-span-3 border p-1">
                    {formatMoney(selected?.opex_amount)}
                  </div>
                  <div className="col-span-3 border p-1">
                    {formatMoney(getAllocatedOpex())}
                  </div>
                  <div className="col-span-3 border p-1">
                    {formatMoney(
                      Number(selected?.opex_amount) - getAllocatedOpex()
                    )}
                  </div>

                  <div className="col-span-3 border p-1">Capital ( Capex )</div>
                  <div className="col-span-3 border p-1">
                    {formatMoney(selected?.capex_amount)}
                  </div>
                  <div className="col-span-3 border p-1">
                    {formatMoney(getAllocatedCapex())}
                  </div>
                  <div className="col-span-3 border p-1">
                    {formatMoney(
                      Number(selected?.capex_amount) - getAllocatedCapex()
                    )}
                  </div>
                </div>
              </div>
              <div className="">
                {selected?.butems?.map((butem: any) => (
                  <div className="p-2 mb-4">
                    <div className="font-bold flex justify-between border-b py-2">
                      <span className="text-lg">{butem?.month_name}</span>
                      {editable?.month_code === butem?.month_code ? (
                        <div className="flex">
                          <button
                            onClick={() => {
                              setEditable(false);
                            }}
                            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer mr-2"
                          >
                            <span>
                              <IoCloseOutline />
                            </span>
                            <span>Cancel</span>
                          </button>
                          <button
                            onClick={() => {
                              handleUpdateButem(butem);
                            }}
                            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-green-100 hover:bg-green-200 cursor-pointer"
                          >
                            <span>
                              <IoSaveOutline />
                            </span>
                            <span>Save</span>
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={() => {
                            setEditable(butem);
                            setOpex(Number(butem.opex_amount));
                            setCapex(Number(butem.capex_amount));
                          }}
                          className="flex justify-center items-center text-gray-700  rounded-md p-2 hover:bg-green-200 cursor-pointer"
                        >
                          <FiEdit />
                        </button>
                      )}
                    </div>
                    <div className="">
                      <div className="flex justify-between py-1">
                        <div className="">Operational Budget</div>
                        <div className="">
                          {editable?.month_code === butem?.month_code ? (
                            <input
                              type="number"
                              name="opex_amount"
                              className="border p-1"
                              defaultValue={Number(butem?.opex_amount)}
                              onChange={(e: any) => setOpex(e.target.value)}
                              placeholder=""
                            />
                          ) : butem?.opex_amount ? (
                            formatMoney(Number(butem?.opex_amount))
                          ) : (
                            0
                          )}
                        </div>
                      </div>
                      <div className="flex justify-between py-1">
                        <div className="">Capital Budget</div>
                        <div className="">
                          {editable?.month_code === butem?.month_code ? (
                            <input
                              type="text"
                              name="capex_amount"
                              className="border p-1"
                              defaultValue={Number(butem?.capex_amount)}
                              onChange={(e: any) => setCapex(e.target.value)}
                              placeholder=""
                            />
                          ) : butem?.capex_amount ? (
                            formatMoney(Number(butem?.capex_amount))
                          ) : (
                            0
                          )}
                        </div>
                      </div>
                      <div className="flex justify-between border-t">
                        <div className="">Total Budget</div>
                        <div className="">
                          {editable?.month_code === butem?.month_code ? (
                            <div className="">
                              {formatMoney(Number(opex) + Number(capex))}
                            </div>
                          ) : (
                            <div className="">
                              {butem?.total_amount
                                ? formatMoney(Number(butem?.total_amount))
                                : 0}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Manage>
  );
}
